export enum ProcureMode {
  BOPIS = 'BOPIS',
  BOPL = 'BOPL',
  CS = 'curbside',
  SAMEDAY = 'SAMEDAY',
  STD = 'standard',
  STH = 'STH',
  STS = 'ship to store',
}
